<!-- Chat Panel -->
@if (uiState?.isOpen) {
  <div class="chat-panel-wrapper" @panelAnimation>
    <app-chat-panel></app-chat-panel>
  </div>
}

<!-- FAB Button -->
<button
  class="chat-fab"
  (click)="toggle()"
  [attr.aria-label]="uiState?.isOpen ? 'Cerrar Billie' : 'Abrir Billie'"
  [class.active]="uiState?.isOpen"
  type="button">

  <!-- Chat icon (when closed) -->
  @if (!uiState?.isOpen) {
    <svg class="fab-icon" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
    </svg>
  }

  <!-- Close icon (when open) -->
  @if (uiState?.isOpen) {
    <svg class="fab-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"></line>
      <line x1="6" y1="6" x2="18" y2="18"></line>
    </svg>
  }

  <!-- Unread badge -->
  @if (!uiState?.isOpen && uiState?.unreadCount > 0) {
    <span class="badge">
      {{ uiState.unreadCount > 9 ? '9+' : uiState.unreadCount }}
    </span>
  }
</button>
